import { stat } from "fs";
import React from "react";
import { Navigate } from "react-router-dom";
import { CheckPermission } from "src/permissions/checkPermission";
import { useAppSelector } from "src/store";

const Authmiddleware = (props: any) => {
  const user = useAppSelector((state) => state.auth.user);
  if (!user) {
    return <Navigate to={{ pathname: "/login" }} />;
  }
  // if (!CheckPermission(user, props.permission)) {
  //   return <Navigate to={{ pathname: "/404" }} />;
  // }
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
